const props = (state) => {
  return {
    store$config: state.config,
    store$focus: state.focus,
  };
};

export default props;
